import { createStore, combineReducers, applyMiddleware, compose } from "redux"
import createHistory from "history/createBrowserHistory"
import { routerReducer, routerMiddleware } from "react-router-redux"
import { parse } from "querystring"
import gaMiddleware from "./gaMiddleware"
import {
  dateRangeReducer,
  updateDateRange,
  dateRangeMiddleware,
} from "./dateRange"

export const updateStaticFilter = (key, value) => {
  return {
    type: "UPDATE_STATIC_FILTER",
    payload: { [key]: value },
  }
}

export const clearStaticFilters = () => {
  return { type: "CLEAR_STATIC_FILTERS" }
}

export const staticFilterReducer = (
  state = { onlyRented: false, onlyStationary: false },
  action
) => {
  switch (action.type) {
    case "UPDATE_STATIC_FILTER":
      return { ...state, ...action.payload }
    case "CLEAR_STATIC_FILTERS":
      return { onlyRented: false, onlyStationary: false }
    default:
      return state
  }
}

export const addAssetFilter = value => {
  return {
    type: "ADD_ASSET_FILTER",
    payload: value,
  }
}

export const removeAssetFilter = value => {
  return {
    type: "REMOVE_ASSET_FILTER",
    payload: value,
  }
}

export const clearAssetFilters = () => {
  return { type: "CLEAR_ASSET_FILTERS" }
}

export const assetFiltersReducer = (state = { selectedAssets: [] }, action) => {
  switch (action.type) {
    case "ADD_ASSET_FILTER":
      return {
        ...state,
        selectedAssets: [...state.selectedAssets, action.payload],
      }
    case "REMOVE_ASSET_FILTER":
      return {
        ...state,
        selectedAssets: state.selectedAssets.filter(
          el => el !== action.payload
        ),
      }
    case "CLEAR_ASSET_FILTERS":
      return { selectedAssets: [] }
    default:
      return state
  }
}

export const searchTermsReducer = (
  state = { keywords: "", unitId: "", departmentId: "" },
  action
) => {
  switch (action.type) {
    case "@@router/LOCATION_CHANGE": {
      const params = parse(action.payload.search.substring(1))
      return {
        keywords: params.keywords,
        departmentId: params.departmentId,
        unitId: params.unitId,
      }
    }
    default:
      return state
  }
}

const storeWithHistory = () => {
  const history = createHistory()
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
  return {
    store: createStore(
      combineReducers({
        router: routerReducer,
        dateRange: dateRangeReducer,
        staticFilters: staticFilterReducer,
        assetFilters: assetFiltersReducer,
        searchTerms: searchTermsReducer,
      }),
      composeEnhancers(
        applyMiddleware(
          routerMiddleware(history),
          gaMiddleware,
          dateRangeMiddleware
        )
      )
    ),
    history: history,
  }
}

export { storeWithHistory as default, updateDateRange }
